import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  id: "preview"
};
const _hoisted_2 = {
  class: "paper-name"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0,
  class: "paper-context"
};
const _hoisted_5 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_6 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_7 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_8 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_9 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_10 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_11 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_12 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_13 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_14 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_15 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_16 = {
  key: 1,
  class: "paper-context"
};
const _hoisted_17 = {
  key: 2,
  class: "paper-context"
};
const _hoisted_18 = {
  key: 3,
  class: "paper-context"
};
const _hoisted_19 = {
  key: 0,
  class: "fast-time"
};
const _hoisted_20 = {
  key: 4,
  class: "paper-context"
};
const _hoisted_21 = {
  key: 5,
  class: "paper-context"
};
const _hoisted_22 = {
  key: 6,
  class: "answer-box"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  class: "menu"
};
const _hoisted_25 = {
  class: "menu"
};
const _hoisted_26 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mm_sequencing = _resolveComponent("mm_sequencing");
  const _component_mcq = _resolveComponent("mcq");
  const _component_sequencing = _resolveComponent("sequencing");
  const _component_saq = _resolveComponent("saq");
  const _component_writing_listen = _resolveComponent("writing_listen");
  const _component_vocabulary_mcq = _resolveComponent("vocabulary_mcq");
  const _component_pwco = _resolveComponent("pwco");
  const _component_proofreading = _resolveComponent("proofreading");
  const _component_el_button = _resolveComponent("el-button");
  const _component_mm_drag = _resolveComponent("mm_drag");
  const _component_mm_mcq = _resolveComponent("mm_mcq");
  const _component_mcq_mmcq = _resolveComponent("mcq_mmcq");
  const _component_mm = _resolveComponent("mm");
  const _component_writing = _resolveComponent("writing");
  const _component_oral = _resolveComponent("oral");
  const _component_MenuBox = _resolveComponent("MenuBox");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString($setup.paperInfo.paperName) + " ", 1), $setup.paperInfo.paperDescription ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString($setup.paperInfo.paperDescription) + ")", 1)) : _createCommentVNode("", true), _createElementVNode("span", null, "级别:" + _toDisplayString($setup.paperInfo.level), 1)]), $setup.paperInfo.items && $setup.paperInfo.skill == 'S1' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag' ? (_openBlock(), _createBlock(_component_mm_sequencing, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' ? (_openBlock(), _createBlock(_component_mcq, {
    key: 1,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[3] || (_cache[3] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'sequencing' ? (_openBlock(), _createBlock(_component_sequencing, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[4] || (_cache[4] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[5] || (_cache[5] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' ? (_openBlock(), _createBlock(_component_saq, {
    key: 3,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      style: {
        "width": "25px",
        "height": "25px"
      },
      onClick: _cache[6] || (_cache[6] = (...args) => _ctx.audioStop && _ctx.audioStop(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[7] || (_cache[7] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'writing' ? (_openBlock(), _createBlock(_component_writing_listen, {
    key: 4,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("div", _hoisted_14, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[8] || (_cache[8] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : _createCommentVNode("", true)])) : $setup.paperInfo.items && $setup.paperInfo.skill == 'S0' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' ? (_openBlock(), _createBlock(_component_vocabulary_mcq, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers
  }, null, 8, ["questionInfo", "onSetAnswer", "allAnswers"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' ? (_openBlock(), _createBlock(_component_mcq, {
    key: 1,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers
  }, null, 8, ["questionInfo", "onSetAnswer", "allAnswers"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' ? (_openBlock(), _createBlock(_component_saq, {
    key: 2,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    skill: "S0"
  }, null, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : _createCommentVNode("", true)])) : $setup.paperInfo.items && $setup.paperInfo.skill == 'S3' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' ? (_openBlock(), _createBlock(_component_mcq, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers
  }, null, 8, ["questionInfo", "onSetAnswer", "allAnswers"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' ? (_openBlock(), _createBlock(_component_saq, {
    key: 1,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, null, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'pwco' ? (_openBlock(), _createBlock(_component_pwco, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'proofreading' ? (_openBlock(), _createBlock(_component_proofreading, {
    key: 3,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)])) : $setup.paperInfo.items && $setup.paperInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [$setup.paperInfo.items[$setup.itemNo].isFast ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px"
    },
    icon: _ctx.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createTextVNode("快速阅读" + _toDisplayString(_ctx.fastTimeText), 1)])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag' ? (_openBlock(), _createBlock(_component_mm_drag, {
    key: 1,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-mcq' ? (_openBlock(), _createBlock(_component_mm_mcq, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'judge' ? (_openBlock(), _createBlock(_component_mcq_mmcq, {
    key: 3,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' ? (_openBlock(), _createBlock(_component_saq, {
    key: 4,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm' ? (_openBlock(), _createBlock(_component_mm, {
    key: 5,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)])) : $setup.paperInfo.items && $setup.paperInfo.skill == 'S4' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag' ? (_openBlock(), _createBlock(_component_mm_drag, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-mcq' ? (_openBlock(), _createBlock(_component_mm_mcq, {
    key: 1,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'writing' ? (_openBlock(), _createBlock(_component_writing, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'proofreading' ? (_openBlock(), _createBlock(_component_proofreading, {
    key: 3,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm' ? (_openBlock(), _createBlock(_component_mm, {
    key: 4,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, null, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true)])) : $setup.paperInfo.items && $setup.paperInfo.skill == 'S5' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_oral, {
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, null, 8, ["questionInfo"])])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_cache[12] || (_cache[12] = _createElementVNode("p", null, "答案：", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paperInfo.items[$setup.itemNo].questionGroupList, (questionGroupListItem, questionGroupListIndex) => {
    return _openBlock(), _createElementBlock("div", {
      style: {
        "display": "flex",
        "flex-wrap": "wrap"
      },
      key: 'questionGroupListIndex' + questionGroupListIndex
    }, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'pwco' ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString($setup.pwcoAnswer(questionGroupListItem.questionList[0].questionKey)), 1)) : $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'proofreading' ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(questionGroupListItem.questionList, (questionListItem, questionListIndex) => {
      return _withDirectives((_openBlock(), _createElementBlock("p", {
        key: 'proofreadingquestionListIndex' + questionListIndex + questionGroupListIndex
      }, [_createElementVNode("span", _hoisted_24, _toDisplayString($setup.paperInfo.items[$setup.itemNo].menu + questionListItem.menuMark + questionListIndex), 1), _createTextVNode(" " + _toDisplayString(questionListItem.questionKey), 1)])), [[_vShow, questionListItem.menuMark || questionListItem.menuMark == 0]]);
    }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 2
    }, _renderList(questionGroupListItem.questionList, (questionListItem, questionListIndex) => {
      return _openBlock(), _createElementBlock("p", {
        key: 'questionListIndex' + questionListIndex + questionGroupListIndex
      }, [_createElementVNode("span", _hoisted_25, _toDisplayString($setup.paperInfo.items[$setup.itemNo].menu + questionGroupListIndex + questionListIndex), 1), _createTextVNode(" " + _toDisplayString(questionListItem.questionKey), 1)]);
    }), 128))]);
  }), 128))])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createBlock(_component_MenuBox, {
    key: 7,
    examType: 3,
    paperInfo: $setup.paperInfo,
    itemNo: $setup.itemNo,
    answers: $setup.cache.answers,
    onChangeItem: _cache[9] || (_cache[9] = no => {
      $setup.itemNo = no;
    })
  }, null, 8, ["paperInfo", "itemNo", "answers"])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createElementBlock("audio", {
    key: 8,
    id: "audio",
    onEnded: _cache[10] || (_cache[10] = (...args) => $setup.audioEnded && $setup.audioEnded(...args)),
    onCanplay: _cache[11] || (_cache[11] = $event => $setup.audioStatus = 'yet'),
    controls: "",
    style: {
      "display": "none"
    },
    preload: "none"
  }, [_createElementVNode("source", {
    src: $setup.paperInfo.items[$setup.itemNo].mediaName && $setup.paperInfo.items[$setup.itemNo].mediaName.indexOf('http') == -1 ? $setup.audioUrl + $setup.paperInfo.items[$setup.itemNo].mediaName : $setup.paperInfo.items[$setup.itemNo].mediaName,
    type: "audio/mpeg"
  }, null, 8, _hoisted_26)], 32)) : _createCommentVNode("", true)]);
}